export const ButtonType = Object.freeze({
    Standard: 'standard',
    WithConfirmation: 'withConfirmation',
    DataGridButton: 'dataGridButton',
    DataGridRowButton: 'dataGridRowButton',
    DataGridRowButtonWithConfirmation: 'dataGridRowButtonWithConfirmation',
});
